import MDButton from '../MDButton'

export default function TableButton({
    color = 'primary',
    children,
    ...props
}) {
    return (
        <MDButton
            variant="outlined"
            color={color}
            {...props}
        >
            {children}
        </MDButton>
    )
}
